import { render, staticRenderFns } from "./px-avatar.vue?vue&type=template&id=36118c3c&scoped=true&"
import script from "./px-avatar.vue?vue&type=script&lang=ts&"
export * from "./px-avatar.vue?vue&type=script&lang=ts&"
import style0 from "./px-avatar.vue?vue&type=style&index=0&id=36118c3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36118c3c",
  null
  
)

export default component.exports